// Lo que la clienta ve de su envio · va dentro de la tarjeta de la guia (EnvioPaqueteria), debajo del rastreo.
//
// 4-nov-2026 (dueño): la clienta debe ver su envio con el detalle del historial de la PWA, por dos caminos. La LIGA
// privada abre sin registrarse, por eso no lleva nombre, direccion ni total. La CUENTA de la app si muestra todo eso,
// por eso enlazarla lo confirma la vendedora: el telefono de una cuenta no se verifica, y el enlace automatico le
// daba el pedido a quien escribiera un telefono ajeno.
//
// .ep-guia pone cualquier <b> en bloque y a 18 px: aqui no se usa <b>.
import React from 'react';
import { fechaCorta } from './rastreoEstados.js';
const { useState, useEffect, useRef } = React;

const CSS = `
.ec{margin-top:12px;padding-top:12px;border-top:1px solid #E2E8F0}
.ec-t{margin:0;font-size:14px;font-weight:600;color:#0F172A;line-height:1.35}
.ec-sec{margin-top:18px}
.ec .c2-btn{margin-top:8px}
.ec-bien{margin:6px 0 0;font-size:12px;color:#14532D;line-height:1.45}
.ec-liga{margin-top:6px}
.ec-et{display:block;margin:10px 0 4px;font-size:12px;color:#64748B;line-height:1.45}
.ec-busca{display:flex;gap:8px}
.ec-busca .c2-in{flex:1;min-width:0}
.ec-busca .c2-btn{width:auto;flex-shrink:0;margin-top:0;min-height:50px;padding:0 14px}
.ec-cta{display:flex;flex-wrap:wrap;align-items:center;gap:8px 10px;margin-top:8px;padding:10px;border:1px solid #E2E8F0}
.ec-cta .d{flex:1;min-width:0}
.ec-cta .n{display:block;font-size:13px;font-weight:600;color:#0F172A;line-height:1.35;overflow-wrap:anywhere}
.ec-cta small{display:block;margin-top:2px;font-size:12px;color:#64748B;line-height:1.4;overflow-wrap:anywhere}
.ec-cta>.c2-btn{width:auto;flex-shrink:0;margin-top:0;min-height:0;padding:8px 14px}
.ec-conf{flex-basis:100%}
`;

// Mismo token que el resto de la app. La tienda contesta HTTP 200 con {ok:false} cuando rechaza algo: por eso se
// revisa `ok` y no solo el estado HTTP.
async function pedir(pedidoId, accion, cuerpo) {
  const tok = localStorage.getItem('token');
  let r;
  try {
    r = await fetch('/api/envios/' + encodeURIComponent(pedidoId) + '/' + accion, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', ...(tok ? { Authorization: 'Bearer ' + tok } : {}) },
      body: JSON.stringify(cuerpo || {}),
    });
  } catch (e) {
    // Sin red el navegador dice "Failed to fetch" o "Load failed": en ingles, y a la vendedora no le dice que hacer.
    throw new Error('revisa tu conexión y vuelve a intentar');
  }
  const j = await r.json().catch(() => null);
  if (!r.ok || !j || j.ok === false) throw new Error((j && (j.error || j.message)) || ('no se pudo (HTTP ' + r.status + ')'));
  return j;
}

// Lo mismo que guarda el servidor en envio.cuenta_app.
const corta = c => ({ id: c.id, nombre: c.nombre, correo: c.correo, tel: c.tel });

// `alta` llega como Y-m-d. Va a mediodia UTC porque fechaCorta resta 6 h: a secas caeria en el dia anterior.
function altaTxt(alta) {
  const dia = /^\d{4}-\d{2}-\d{2}$/.test(alta || '') ? fechaCorta(alta + 'T12:00:00Z') : '';
  return dia ? 'Alta ' + dia + ' ' + alta.slice(0, 4) : '';
}

const selecciona = e => e.target.select();

export default function EnvioClienta({ pedidoId, envio, onCambio }) {
  const espejo = (envio && envio.espejo_wc) || null;
  // Sin el dato no cuenta como enlazado, igual que GET /pedidos: "enlazado" solo se dice cuando consta.
  const enlazado = !!envio && envio.espejo_invitado === false;
  const cuenta = (envio && envio.cuenta_app) || null;

  const [liga, setLiga] = useState('');
  const [copiando, setCopiando] = useState(false);
  const [copiada, setCopiada] = useState(false);
  const [manual, setManual] = useState(false);
  const [errLiga, setErrLiga] = useState('');

  const [abierta, setAbierta] = useState(false);
  const [q, setQ] = useState('');
  const [cuentas, setCuentas] = useState(null);       // null = todavia no hay respuesta que mostrar
  const [buscando, setBuscando] = useState(false);
  const [porConfirmar, setPorConfirmar] = useState(null);   // el user_id por confirmar; 0 = quitar, como en /enlazar
  const [enlazando, setEnlazando] = useState(false);
  const [revisando, setRevisando] = useState(false);
  const [errCuenta, setErrCuenta] = useState('');

  const vivo = useRef(true);
  const yaRevisada = useRef(false);

  useEffect(() => {
    vivo.current = true;
    return () => { vivo.current = false; };
  }, []);

  // Enlazado y sin saber a quien: pasa con un espejo que el telefono enlazo antes del 4-nov, y con el conector viejo
  // pudo quedar marcado sin estarlo. El sitio es quien lo sabe. Se pregunta una vez: la vendedora debe ver de quien es
  // la cuenta, porque ese enlace nadie lo confirmo.
  useEffect(() => {
    if (yaRevisada.current || !espejo || !enlazado || cuenta) return;
    yaRevisada.current = true;
    setRevisando(true);
    pedir(pedidoId, 'cuentas')
      .then(j => {
        if (onCambio) onCambio(j.actual ? { cuenta_app: corta(j.actual) } : { espejo_invitado: true, cuenta_app: null });
      })
      .catch(e => { if (vivo.current) setErrCuenta('No se pudo revisar la cuenta enlazada: ' + e.message); })
      .finally(() => { if (vivo.current) setRevisando(false); });
  }, [espejo, enlazado, cuenta, pedidoId, onCambio]);

  const copiar = async () => {
    setErrLiga(''); setCopiada(false);
    let url = liga;
    if (!url) {
      setCopiando(true);
      try {
        url = (await pedir(pedidoId, 'liga')).url;
        if (vivo.current) setLiga(url);
      } catch (e) {
        if (vivo.current) setErrLiga('No se pudo sacar la liga: ' + e.message);
        return;
      } finally {
        if (vivo.current) setCopiando(false);
      }
    }
    // El iPhone suele negar copiar despues de un await, y en otros navegadores clipboard ni existe. Ya con la liga en
    // pantalla, un segundo toque copia directo porque ya no hay await de por medio.
    try {
      await navigator.clipboard.writeText(url);
      if (vivo.current) { setCopiada(true); setManual(false); }
    } catch (e) {
      if (vivo.current) setManual(true);
    }
  };

  const buscar = async (texto) => {
    const t = (texto || '').trim();
    // Los resultados anteriores se quitan primero: si esta busqueda falla no deben quedar a la vista como si fueran
    // de lo recien escrito, porque alguien podria enlazar a una cuenta que no es.
    setAbierta(true); setBuscando(true); setErrCuenta(''); setPorConfirmar(null); setCuentas(null);
    try {
      const j = await pedir(pedidoId, 'cuentas', t ? { q: t } : {});
      // El sitio ya lo tiene enlazado aunque aqui diga que no (un reclamo por telefono de antes del 4-nov no llego a la
      // PWA). Se muestra eso: buscar otra cuenta encima cambiaria el enlace sin que nadie viera el anterior.
      if (j.actual) {
        if (onCambio) onCambio({ espejo_invitado: false, cuenta_app: corta(j.actual) });
        if (vivo.current) setAbierta(false);
        return;
      }
      if (vivo.current) setCuentas(Array.isArray(j.cuentas) ? j.cuentas.filter(c => c && c.id) : []);
    } catch (e) {
      if (vivo.current) setErrCuenta('No se pudo buscar: ' + e.message);
    } finally {
      if (vivo.current) setBuscando(false);
    }
  };

  const aplicar = async (userId) => {
    setPorConfirmar(null); setEnlazando(true); setErrCuenta('');
    try {
      const j = await pedir(pedidoId, 'enlazar', { user_id: userId });
      // Va aunque la pantalla ya se haya cerrado: la lista de envios debe enterarse del cambio.
      if (onCambio) onCambio({ espejo_invitado: j.espejo_invitado, cuenta_app: j.cuenta_app || null });
      if (vivo.current) { setAbierta(false); setCuentas(null); setQ(''); }
    } catch (e) {
      if (vivo.current) setErrCuenta((userId ? 'No se pudo enlazar: ' : 'No se pudo quitar el enlace: ') + e.message);
    } finally {
      if (vivo.current) setEnlazando(false);
    }
  };

  if (!espejo) return null;

  const ocupado = buscando || enlazando;

  // Mismo patron que "Generar la guia" en EnvioPaqueteria: la pregunta en la pantalla, con Cancelar y Si.
  const confirma = (texto, si) => (
    <div className="ec-conf">
      <p className="ep-nota" style={{ margin: 0 }}>{texto}</p>
      <div className="c3-2b" style={{ marginTop: 0 }}>
        <button type="button" className="c2-btn ghost" onClick={() => setPorConfirmar(null)}>Cancelar</button>
        <button type="button" className="c2-btn" onClick={() => aplicar(porConfirmar)}>{si}</button>
      </div>
    </div>
  );

  return (
    <div className="ec" data-ec="clienta">
      <style>{CSS}</style>

      <p className="ec-t">Liga de rastreo para la clienta</p>
      <button type="button" className="c2-btn ghost" onClick={copiar} disabled={copiando}>
        {copiando ? 'Preparando…' : 'Copiar liga'}
      </button>
      {copiada && <p className="ec-bien" role="status">Liga copiada. Pégala en el chat.</p>}
      {manual && liga && (<>
        <p className="ep-nota">No se pudo copiar sola. Mantén presionada la liga para copiarla.</p>
        <input className="c2-in ec-liga" readOnly value={liga} aria-label="Liga de rastreo" onFocus={selecciona} onClick={selecciona} />
      </>)}
      {errLiga && <div className="c2-err" role="alert">{errLiga}</div>}
      <p className="ep-nota">Mándasela por el chat. Abre sin registrarse y no lleva nombre, dirección ni total.</p>

      <div className="ec-sec">
        <p className="ec-t">Cuenta de la app</p>
        {enlazado ? (<>
          {revisando
            ? <p className="ep-nota">Revisando la cuenta enlazada…</p>
            : <p className="ep-nota">{cuenta && cuenta.nombre ? 'Enlazado a la cuenta de ' + cuenta.nombre + '.' : 'Enlazado a una cuenta de la app.'}</p>}
          {porConfirmar === 0
            ? confirma('¿Quitar el enlace? Ella ya no verá este pedido en su app.', 'Sí, quitar')
            : <button type="button" className="c2-btn ghost" disabled={enlazando || revisando} onClick={() => setPorConfirmar(0)}>
                {enlazando ? 'Quitando…' : 'Quitar enlace'}
              </button>}
        </>) : (<>
          <p className="ep-nota">Sin cuenta enlazada. Para que lo vea dentro de su app, enlázalo a su cuenta.</p>
          {!abierta ? (
            <button type="button" className="c2-btn ghost" onClick={() => buscar('')}>Buscar su cuenta</button>
          ) : (<>
            <form onSubmit={e => { e.preventDefault(); buscar(q); }}>
              <label className="ec-et" htmlFor="ec-q">Teléfono o correo con el que se registró</label>
              <div className="ec-busca">
                <input id="ec-q" className="c2-in" value={q} maxLength={120} autoComplete="off" autoCapitalize="none"
                  spellCheck={false} onChange={e => setQ(e.target.value)} />
                <button type="submit" className="c2-btn" disabled={ocupado || !q.trim()}>Buscar</button>
              </div>
            </form>
            {buscando && <p className="ep-nota">Buscando…</p>}
            {enlazando && <p className="ep-nota">Guardando en la tienda…</p>}
            {cuentas && cuentas.length === 0 && <p className="ep-nota">No hay ninguna cuenta con esos datos.</p>}
            {cuentas && cuentas.map(c => (
              <div className="ec-cta" key={c.id} data-ec="cuenta">
                <span className="d">
                  <span className="n">{c.nombre}</span>
                  <small>{[c.correo, c.tel, altaTxt(c.alta)].filter(Boolean).join(' · ')}</small>
                </span>
                {porConfirmar === c.id
                  ? confirma('¿Es la cuenta de esta clienta? En esa cuenta se verá este pedido: total, artículos, guía y quién recibió.', 'Sí, enlazar')
                  : <button type="button" className="c2-btn ghost" disabled={ocupado} onClick={() => setPorConfirmar(c.id)}>Enlazar</button>}
              </div>
            ))}
          </>)}
        </>)}
        {errCuenta && <div className="c2-err" role="alert">{errCuenta}</div>}
      </div>
    </div>
  );
}
